import React from 'react';
import { TeamEvent } from '../types/games_api_types';
import { scheduleItemTimeString } from '../utils';
import { useContentVisibility } from '../hooks/useContentVisibility';
import classes from './TeamEventScorecard.module.css';

export default function TeamEventScorecard({
  teamEvent,
}: {
  teamEvent: TeamEvent;
}) {
  const { showStudentAthletes } = useContentVisibility();

  return (
    <div
      className={[
        classes.teamEventScorecard,
        showStudentAthletes ? '' : classes.noAthlete,
      ].join(' ')}
    >
      {showStudentAthletes && (
        <img
          className={classes.slantedHero}
          src={`/images/today/${teamEvent.season}-${teamEvent.sport}.png`}
        />
      )}

      <div className={classes.header}>
        <div>{teamEvent.name}</div>
        <div className={classes.right}>
          {teamEvent.tv_channel !== null ? `${teamEvent.tv_channel} - ` : ''}
          {scheduleItemTimeString(teamEvent)}
        </div>
      </div>
    </div>
  );
}
